/* eslint-disable */
// This code is autogenerated using @harnessio/oats-cli.
// Please do not modify this code directly.
import type { PaginatedBrandKitTemplateResponseList } from '../schemas/PaginatedBrandKitTemplateResponseList';
import { fetcher, FetcherOptions } from './fetcher';

export interface BrandTemplateListAPIQueryParams {
  has_organization?: boolean;
  layout?: 'AUDIOGRAM' | 'DEFAULT' | 'GRID' | 'SPEAKER';
  limit?: number;
  offset?: number;
  size?: 'LANDSCAPE' | 'PORTRAIT' | 'SQUARE';
  tags?: string;
  title?: string;
}

export type BrandTemplateListOkResponse = PaginatedBrandKitTemplateResponseList;

export type BrandTemplateListErrorResponse = unknown;

export interface BrandTemplateListProps
  extends Omit<
    FetcherOptions<BrandTemplateListAPIQueryParams, unknown>,
    'url'
  > {
  queryParams: BrandTemplateListAPIQueryParams;
}

export function brandTemplateList(
  props: BrandTemplateListProps
): Promise<BrandTemplateListOkResponse> {
  return fetcher<
    BrandTemplateListOkResponse,
    BrandTemplateListAPIQueryParams,
    unknown
  >({
    url: `/brand_template/`,
    method: 'GET',
    ...props
  });
}
